/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useMemo } from "react";
import {
  NotificationGroup,
  NotificationGroupSortFields,
  SortOrder,
} from "~/generated/graphql";
import { ColumnType, SelectionMethod } from "~/types";
import { useGetNotificationGroups } from "~/views/notificationGroups/hooks/useGetNotificationGroups/useGetNotificationGroups";

export function useGetNotificationGroupsAsSidebarItems() {
  const {
    data,
    count: total = 0,
    loading,
    noData,
  } = useGetNotificationGroups({
    page: "1",
    limit: "100",
    sort: {
      field: NotificationGroupSortFields.Name,
      order: SortOrder.Asc,
    },
  });

  const options = useMemo(
    () =>
      data.map((notificationGroup: NotificationGroup) => {
        return {
          name: notificationGroup?.name ?? "",
          id: notificationGroup?.id ?? "",
          tag: SelectionMethod.manual,
          columns: [
            {
              data: [
                notificationGroup?.name ?? "",
                notificationGroup?.id ?? "",
              ],
              type: ColumnType.text,
            },
          ],
        };
      }),
    [data]
  );

  return {
    options,
    total,
    loading,
    noData,
  };
}
